import { css } from '@emotion/react'

export const styles = css`
  .custom-content-marker {
    width: 20px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    pointer-events: none;
  }
  .custom-icon {
    width: 20px;
    height: 28px;
  }
`
